var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button-dashboard-chapter",attrs:{"to":{
    name: "Study",
    params: { categoryId: _vm.categoryId, lessonId: _vm.lessonId, chapterId: _vm.chapterId }
  }}},[_c('div',{staticClass:"button-dashboard-chapter__check",class:_vm.addClass},[(_vm.check)?_c('i',{staticClass:"fas fa-check"}):_vm._e()]),_c('div',{staticClass:"button-dashboard-chapter__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }